export default __webpack_public_path__ + "static/media/testdark.f20083c9.svg";